<template>

    <card id="offerid" header-classes="bg-transparent" body-classes="px-lg-3"
        class="card-pricing border-0 text-center mb-4">

        <!-- h2>OFFERS LIST ELEMENT</h2 -->

        {{ offer.asig_name }}

        <!-- h4 slot="header" class="text-uppercase ls-1 text-primary py-3 mb-0">Bravo pack</h4 -->

        <div class="display-2">{{ financial(offer.sum_brut) }} €</div>
        <span class="text-muted">per application</span>
        <ul class="list-unstyled my-4">
            <li>
                <div class="d-flex align-items-center">
                    <div>
                        <div class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white">
                            <i class="fas fa-terminal"></i>
                        </div>
                    </div>
                    <div>
                        <span class="pl-2">Complete documentation</span>
                    </div>
                </div>
            </li>
            <li>
                <div class="d-flex align-items-center">
                    <div>
                        <div class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white">
                            <i class="fas fa-pen-fancy"></i>
                        </div>
                    </div>
                    <div>
                        <span class="pl-2">Working materials in Sketch</span>
                    </div>
                </div>
            </li>
            <li>
                <div class="d-flex align-items-center">
                    <div>
                        <div class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white">
                            <i class="fas fa-hdd"></i>
                        </div>
                    </div>
                    <div>
                        <span class="pl-2">2GB cloud storage</span>
                    </div>
                </div>
            </li>
        </ul>

        <base-button type="primary" class="mb-3">Auswählen</base-button>

    </card>

</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
    name: "softfair-offers-list-element",
    props: {
        offer: {
            type: Object,
            required: 1,
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
    financial(x) {
      if (isNaN(Number.parseFloat(x).toFixed(2))) {
        return 0;
      }
      return Number.parseFloat(x).toFixed(2);
    },
    },
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
        }),
    },
    mounted() {
        console.log("THE offer within offers-list-element");
        console.log(this.offer);    
        console.log("THE offer within offers-list-element");
    },
};
</script>
<style></style>